<app-card [cardClasses]="cardClasses">
  <div cardBody class="d-flex flex-wrap flex-sm-nowrap">
    <div class="me-7 mb-4 mb-lg-0">
      <div class="symbol symbol-48px symbol-lg-100px symbol-fixed position-relative">
        <app-skeleton-text [isLoading]="isLoading" type="image">
          <div class="icon">
            <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_DANGER" class="svg-icon svg-icon-48"></span>
          </div>
        </app-skeleton-text>
      </div>
    </div>

    <div>
      <app-skeleton-text [isLoading]="isLoading" class="expired" type="text">{{ textTitle }} </app-skeleton-text>
      <div class="d-flex">
        <app-skeleton-text [isLoading]="isLoading" class="date" type="text">{{ date }}</app-skeleton-text>
        <app-skeleton-text [isLoading]="isLoading" class="leftday" type="text">tersisa {{ days }} hari </app-skeleton-text>
      </div>
    </div>
  </div>
</app-card>
